"use client";
import * as React from "react";
const SvgVerifiedSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16 8-1.774-1.993.247-2.636-2.626-.585L10.473.5 8 1.543 5.527.5 4.153 2.779l-2.626.578L1.775 6 0 8l1.775 1.993-.248 2.643 2.626.585L5.527 15.5 8 14.45l2.473 1.043 1.374-2.279 2.626-.585-.248-2.636L16 8Zm-9.39 3.371L3.848 8.65l1.077-1.057L6.61 9.257l4.255-4.193 1.076 1.057-5.331 5.25Z" }));
export {
  SvgVerifiedSharp as default
};
